






















































































































import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/ru";

import { STORE_KEY, store } from "./_store";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading_category",
      "loaded_category",
      "loading_shipment_forecast_week_plan",
      "production_plan_recalc_loading",
      "transport_chart_cache_loading"
    ]),
    ...mapState("ubic", ["actor"])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      "recalcCategory",
      "recalcShipmentForecastWeekPlan",
      "recalculateProductionPlan",
      "recalculateTransportChartCache"
    ])
  },
  components: {
    TitleBar
  }
})
export default class Utils extends Vue {
  actor!: any;
  filter!: any;
  employees!: any[];
  loading_shipment_forecast_week_plan!: boolean;
  transport_chart_cache_loading!: boolean;
  recalcShipmentForecastWeekPlan!: () => Promise<any>;
  recalculateTransportChartCache!: (months: number) => Promise<any>;

  get titleStack() {
    return ["Инструменты"];
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  opendeSources: any[] = [];

  public mounted() {
    this.handleParamsChange();
  }

  // ---------------------------------------------------------------------------

  public handleParamsChange() {
    //
  }

  promptTransportChartCacheRebuild() {
    this.$buefy.dialog.prompt({
      message: "Количество месяцев для пересчёта (1–24)",
      inputAttrs: {
        type: "number",
        min: 1,
        max: 24,
        value: "6"
      },
      trapFocus: true,
      onConfirm: (value: string) => {
        const n = parseInt(value, 10);
        if (isNaN(n) || n < 1 || n > 24) {
          this.$buefy.toast.open({
            message: "Введите целое число от 1 до 24",
            type: "is-warning"
          });
          return;
        }
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.debug("[client_transport_cache_manual] requested", { months: n });
        }
        this.recalculateTransportChartCache(n);
      }
    });
  }
}
